module.exports = __webpack_public_path__ + "static/media/Pokana_Formoplast_OSA_16.02.2018.151de7b0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Pokana_Formoplast_OSA_16.02.2018.pdf
// module id = 143
// module chunks = 0